import React, { useState } from "react";
import { loginWithGoogle, signInWithEmail, registerLogin } from "./Auth";

import googleIcon from "../../assets/web_light_rd_SU.svg";
import memoLocks from "../../assets/logo_memolock.svg";

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleGoogleSignIn = async () => {
    setError(null);
    setLoading(true);
    try {
      await loginWithGoogle();
    } catch (err) {
      setError(err?.message || "Google login failed");
      console.error("Login error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleEmailPasswordSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setError("Please fill in all fields.");
      return;
    }
    setError(null);
    setLoading(true);
    try {
      // Sign in with Firebase.
      const user = await signInWithEmail(email, password);

      // Register the successful login in Cosmos DB.
      await registerLogin(user);
    } catch (err) {
      // Firebase provides more user-friendly error messages
      setError(
        err.message.replace("Firebase: ", "").replace(/\(auth.*\)\.?/, ""),
      );
      console.error("Email/Password auth error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="p-8 rounded-lg shadow-lg bg-white w-full max-w-md">
        <img src={memoLocks} alt="Logo" className="mx-auto mb-6 h-16 w-auto" />
        <h2 className="mb-6 text-3xl font-bold text-center text-gray-800">
          Sign In
        </h2>

        <form onSubmit={handleEmailPasswordSubmit}>
          <div className="mb-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="email"
            >
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="email@example.com"
              className="shadow-sm appearance-none border rounded w-full py-2 px-3 text-[#222731] leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="mb-6">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="password"
            >
              Password
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="******************"
              className="shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="flex items-center justify-between mb-4">
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#48CFCB] hover:bg-[#229799] text-[#222731] font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline disabled:opacity-50 transition duration-300"
            >
              {loading ? "Signing In..." : "Sign In"}
            </button>
          </div>
        </form>

        {/* <div className="my-4 flex items-center">
          <div className="flex-grow border-t border-gray-300"></div>
          <span className="flex-shrink mx-4 text-gray-400">or</span>
          <div className="flex-grow border-t border-gray-300"></div>
        </div>

        <div className="flex justify-center">
          <button
            onClick={handleGoogleSignIn}
            disabled={loading}
            className="bg-transparent border-0 p-0"
          >
            <img
              src={googleIcon}
              alt="Sign in with Google"
              className="cursor-pointer"
            />
          </button>
        </div> */}

        {error && (
          <div className="mt-4 text-center p-2 bg-red-100 border border-red-400 text-red-700 rounded">
            {error}
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginPage;
